import { defineComponent as fe, ref as H, inject as M, toRef as I, computed as C, useSlots as ve, watch as be, openBlock as p, createElementBlock as f, normalizeClass as r, createElementVNode as o, unref as e, renderSlot as y, Fragment as ge, renderList as he, toDisplayString as L, createCommentVNode as A, createVNode as i, withCtx as V } from "vue";
import q from "./index592.js";
import { DArrowLeft as G, DArrowRight as Q } from "./index537.js";
import { ElIcon as Y } from "./index538.js";
import { panelYearRangeEmits as ke, panelYearRangeProps as Ce } from "./index871.js";
import { useYearRangeHeader as ye } from "./index872.js";
import { useRangePicker as _e } from "./index867.js";
import { isValidRange as De, correctlyParseUserInput as Pe, getDefaultValue as we } from "./index862.js";
import { ROOT_PICKER_IS_DEFAULT_FORMAT_INJECTION_KEY as Re } from "./index632.js";
import W from "./index865.js";
import { useLocale as Ve } from "./index597.js";
import { PICKER_BASE_INJECTION_KEY as Ye } from "./index579.js";
import { useFormDisabled as Be } from "./index586.js";
const Se = ["disabled", "onClick"], Ee = ["disabled"], Ne = ["disabled"], Ie = ["disabled"], Le = ["disabled"], v = 10, _ = "year";
var Ge = /* @__PURE__ */ fe({
  name: "DatePickerYearRange",
  __name: "panel-year-range",
  props: Ce,
  emits: ke,
  setup(X, { emit: Z }) {
    const d = X, b = Z, { lang: D } = Ve(), g = H(q().locale(D.value)), c = H(q().locale(D.value).add(v, _)), ee = M(
      Re,
      void 0
    ), m = M(Ye), { shortcuts: K, disabledDate: h, cellClassName: O } = m.props, ae = I(m.props, "format"), $ = I(m.props, "defaultValue"), {
      minDate: P,
      maxDate: w,
      rangeState: B,
      ppNs: n,
      drpNs: k,
      handleChangeRange: x,
      handleRangeConfirm: te,
      handleShortcutClick: ne,
      onSelect: S,
      parseValue: le
    } = _e(d, {
      defaultValue: $,
      leftDate: g,
      rightDate: c,
      step: v,
      unit: _,
      sortDates: pe
    }), {
      leftPrevYear: F,
      rightNextYear: T,
      leftNextYear: U,
      rightPrevYear: j,
      leftLabel: re,
      rightLabel: se,
      leftYear: oe,
      rightYear: ie
    } = ye({
      unlinkPanels: I(d, "unlinkPanels"),
      leftDate: g,
      rightDate: c
    }), s = Be(), J = C(() => !!K.length), de = C(() => [
      n.b(),
      k.b(),
      n.is("border", d.border),
      n.is("disabled", s.value),
      {
        "has-sidebar": !!ve().sidebar || J.value
      }
    ]), E = C(() => ({
      content: [n.e("content"), k.e("content"), "is-left"],
      arrowLeftBtn: [n.e("icon-btn"), "d-arrow-left"],
      arrowRightBtn: [
        n.e("icon-btn"),
        n.is("disabled", !R.value || s.value),
        "d-arrow-right"
      ]
    })), N = C(() => ({
      content: [n.e("content"), k.e("content"), "is-right"],
      arrowLeftBtn: [
        n.e("icon-btn"),
        n.is("disabled", !R.value || s.value),
        "d-arrow-left"
      ],
      arrowRightBtn: [n.e("icon-btn"), "d-arrow-right"]
    })), R = C(() => d.unlinkPanels && ie.value > oe.value + 1), z = (a, t = !0) => {
      const l = a.minDate, u = a.maxDate;
      w.value === u && P.value === l || (b("calendar-change", [l.toDate(), u && u.toDate()]), w.value = u, P.value = l, t && te());
    }, ue = (a) => Pe(
      a,
      ae.value,
      D.value,
      ee
    ), ce = (a) => De(a) && (h ? !h(a[0].toDate()) && !h(a[1].toDate()) : !0), me = () => {
      let a = null;
      m?.emptyValues && (a = m.emptyValues.valueOnClear.value);
      const t = we(e($), {
        lang: e(D),
        step: v,
        unit: _,
        unlinkPanels: d.unlinkPanels
      });
      g.value = t[0], c.value = t[1], b("pick", a);
    };
    function pe(a, t) {
      if (d.unlinkPanels && t) {
        const l = a?.year() || 0, u = t.year();
        c.value = l + v > u ? t.add(v, _) : t;
      } else
        c.value = g.value.add(v, _);
    }
    return be(
      () => d.visible,
      (a) => {
        !a && B.value.selecting && (le(d.parsedValue), S(!1));
      }
    ), b("set-picker-option", ["isValidValue", ce]), b("set-picker-option", ["parseUserInput", ue]), b("set-picker-option", ["handleClear", me]), (a, t) => (p(), f(
      "div",
      {
        class: r(de.value)
      },
      [
        o(
          "div",
          {
            class: r(e(n).e("body-wrapper"))
          },
          [
            y(a.$slots, "sidebar", {
              class: r(e(n).e("sidebar"))
            }),
            J.value ? (p(), f(
              "div",
              {
                key: 0,
                class: r(e(n).e("sidebar"))
              },
              [
                (p(!0), f(
                  ge,
                  null,
                  he(e(K), (l, u) => (p(), f("button", {
                    key: u,
                    type: "button",
                    class: r(e(n).e("shortcut")),
                    disabled: e(s),
                    onClick: (Ae) => e(ne)(l)
                  }, L(l.text), 11, Se))),
                  128
                  /* KEYED_FRAGMENT */
                ))
              ],
              2
              /* CLASS */
            )) : A("v-if", !0),
            o(
              "div",
              {
                class: r(e(n).e("body"))
              },
              [
                o(
                  "div",
                  {
                    class: r(E.value.content)
                  },
                  [
                    o(
                      "div",
                      {
                        class: r(e(k).e("header"))
                      },
                      [
                        o("button", {
                          type: "button",
                          class: r(E.value.arrowLeftBtn),
                          disabled: e(s),
                          onClick: t[0] || (t[0] = //@ts-ignore
                          (...l) => e(F) && e(F)(...l))
                        }, [
                          y(a.$slots, "prev-year", {}, () => [
                            i(e(Y), null, {
                              default: V(() => [
                                i(e(G))
                              ]),
                              _: 1
                              /* STABLE */
                            })
                          ])
                        ], 10, Ee),
                        a.unlinkPanels ? (p(), f("button", {
                          key: 0,
                          type: "button",
                          disabled: !R.value || e(s),
                          class: r(E.value.arrowRightBtn),
                          onClick: t[1] || (t[1] = //@ts-ignore
                          (...l) => e(U) && e(U)(...l))
                        }, [
                          y(a.$slots, "next-year", {}, () => [
                            i(e(Y), null, {
                              default: V(() => [
                                i(e(Q))
                              ]),
                              _: 1
                              /* STABLE */
                            })
                          ])
                        ], 10, Ne)) : A("v-if", !0),
                        o(
                          "div",
                          null,
                          L(e(re)),
                          1
                          /* TEXT */
                        )
                      ],
                      2
                      /* CLASS */
                    ),
                    i(W, {
                      "selection-mode": "range",
                      date: g.value,
                      "min-date": e(P),
                      "max-date": e(w),
                      "range-state": e(B),
                      "disabled-date": e(h),
                      disabled: e(s),
                      "cell-class-name": e(O),
                      onChangerange: e(x),
                      onPick: z,
                      onSelect: e(S)
                    }, null, 8, ["date", "min-date", "max-date", "range-state", "disabled-date", "disabled", "cell-class-name", "onChangerange", "onSelect"])
                  ],
                  2
                  /* CLASS */
                ),
                o(
                  "div",
                  {
                    class: r(N.value.content)
                  },
                  [
                    o(
                      "div",
                      {
                        class: r(e(k).e("header"))
                      },
                      [
                        a.unlinkPanels ? (p(), f("button", {
                          key: 0,
                          type: "button",
                          disabled: !R.value || e(s),
                          class: r(N.value.arrowLeftBtn),
                          onClick: t[2] || (t[2] = //@ts-ignore
                          (...l) => e(j) && e(j)(...l))
                        }, [
                          y(a.$slots, "prev-year", {}, () => [
                            i(e(Y), null, {
                              default: V(() => [
                                i(e(G))
                              ]),
                              _: 1
                              /* STABLE */
                            })
                          ])
                        ], 10, Ie)) : A("v-if", !0),
                        o("button", {
                          type: "button",
                          class: r(N.value.arrowRightBtn),
                          disabled: e(s),
                          onClick: t[3] || (t[3] = //@ts-ignore
                          (...l) => e(T) && e(T)(...l))
                        }, [
                          y(a.$slots, "next-year", {}, () => [
                            i(e(Y), null, {
                              default: V(() => [
                                i(e(Q))
                              ]),
                              _: 1
                              /* STABLE */
                            })
                          ])
                        ], 10, Le),
                        o(
                          "div",
                          null,
                          L(e(se)),
                          1
                          /* TEXT */
                        )
                      ],
                      2
                      /* CLASS */
                    ),
                    i(W, {
                      "selection-mode": "range",
                      date: c.value,
                      "min-date": e(P),
                      "max-date": e(w),
                      "range-state": e(B),
                      "disabled-date": e(h),
                      disabled: e(s),
                      "cell-class-name": e(O),
                      onChangerange: e(x),
                      onPick: z,
                      onSelect: e(S)
                    }, null, 8, ["date", "min-date", "max-date", "range-state", "disabled-date", "disabled", "cell-class-name", "onChangerange", "onSelect"])
                  ],
                  2
                  /* CLASS */
                )
              ],
              2
              /* CLASS */
            )
          ],
          2
          /* CLASS */
        )
      ],
      2
      /* CLASS */
    ));
  }
});
export {
  Ge as default
};
